import React from 'react'
import './DevSecOpsHero.scss'

export class DevSecOpsHero extends React.Component {
  render() {
    return (
      <div
        className="devsecops-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>DevSecOps Excellence</h1>
            <h2>Industry-Leading Platform Engineering and Secure Software Delivery</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default DevSecOpsHero
